import { createContext } from "react";

export const loaderContext = createContext<{
  trigger: boolean;
  setTrigger?: React.Dispatch<React.SetStateAction<boolean>>;
}>({ trigger: false });
